import React from "react";
import { Link } from "react-router-dom";
import "./footer.css";

function Footer() {
  return (
    <div className="container">
      <div className="row">
        <div className="col-sm-12 col-md-3">
          <h2 className="fs-5 m-3">ООО «ABSOLUTE BUSINESS TRADE»</h2>
        </div>
        <div className="col-sm-12 col-md-6">
          <h2  
          style={{
            fontSize:'12px'
          }}
          className=" m-3">
            <Link 
            style={{
                textDecoration:'underline'
            }}
            to="smth">Правила обработки персональных данных</Link>
            <br />
            <br />
            <br />
            Копирование любого материала с настоящего сайта допускается только с письменного разрешения администрации сайта. Информация о ценах, планировках, а также специальных предложениях, размещенных на данном сайте, носит исключительно ознакомительный характер, не является публичной офертой, определяемой статьей 369 ГК РУз. Представленные на сайте изображения объекта носят предварительный ознакомительный характер и могут отличаться от фактических проектных решений, реализуемых застройщиком.
          </h2>
        </div>
        <div className="col-sm-12 col-md-3">
          <h2 className="fs-5 text-center m-3">Logo partner</h2>
        </div>
      </div>
    </div>
  );
}

export default Footer;
